<div class="popup">
  <h2 i18n="@@AddSpecificationByFile">Добавить товар файлом</h2>
  <p>
    <span i18n="@@UploadFileWithProducts">Загрузите файл с товарами. Файл должен состоять из двух колонок без заголовков. В первой колонке укажите коммерческий код товара. Во второй нужное количество в виде целого числа. Каждый товар укажите с новой строки.</span>
    <span i18n="@@AdmissibleFileFormat">Допустимые форматы файлов: XLS, XLSX, TXT и CSV с разделителями точка с запятой</span>
  </p>

  <form aria-labelledby="title" [formGroup]="inputForm" (ngSubmit)="onSubmit()">
      <div class="form-content file-type">
        <input
          type="file"
          id="inputGroupFile01"
          ng2FileSelect [uploader]="uploader"
          (change)="onChange($event)"
          aria-describedby="inputGroupFileAddon01"
          accept=".txt,.xls,.xlsx,.csv">
        <label class="form-label" for="inputGroupFile01"><span>{{ fileName }}</span></label>
      </div>
      <nb-card-footer>
        <label class="label-error suggest-file-error" i18n="@@FileTypeError" *ngIf="fileTypeError">
          Данный формат файла не поддерживается
        </label>
        <button nbButton
                i18n="@@Farther"
                type="submit"
                nbSpinnerStatus="control"
                size="large"
                class="appearance-filled shape-rectangle status-basic size-large"
                [nbSpinner]="submitted"
                [disabled]="!inputForm.valid || submitted">
          Далее
        </button>
        <button class="appearance-filled shape-rectangle status-basic size-large" size="large" type="button" nbButton i18n="@@Cancel" (click)="close()">
          Отмена
        </button>
      </nb-card-footer>
      <nb-alert status="danger" *ngIf="showFail" i18n="@@ErrorOccurred">Возникла ошибка</nb-alert>
  </form>
</div>
